// 初始化数据模块
import {getPersonInfo} from '../../axios/api.js';
import {getArticleDetail, getArticleIndex} from '../../axios/index.js';

import {
	CONFIG,
	TEMPLATE,
	SHARE_INFO,
	PAGE_ROUTES,
  ARTICLE
} from '../types.js'
const state = {
	config: sessionStorage.getItem('config') ? JSON.parse(sessionStorage.getItem('config')) : {},
	routes: [],
  article:[],
	template: sessionStorage.getItem('template') ? JSON.parse(sessionStorage.getItem('template')) : {},
	hasTemplate: true, //是否有模板数据
	shareInfo: {
		goodsList: [],
		perGoodsList: [],
		directOrderInfo: null,
		isDirect: false, 
	},
}

const actions = {

	appInit({
		commit
	}, options) {
		return new Promise((resolve, reject) => {
      getPersonInfo().then(res=>{
        if (res.code === 1) {
        	commit('CONFIG', res.data);
        }
        resolve(res.data)
      }).catch(e => {
				reject(e)
			})

		})
	},

  apparticlelist({
  	commit
  }, options) {
  	return new Promise((resolve, reject) => {
      getArticleIndex().then(res=>{
        if (res.code === 1) {
        	commit('ARTICLE', res.data);
        }
        resolve(res.data)
      }).catch(e => {
  			reject(e)
  		})

  	})
  },
  apparticledetail({
  	commit,
  }, options) {
  	return new Promise((resolve, reject) => {
      getArticleDetail(options).then(res=>{
        if (res.code === 1) {
        	commit('ARTICLE', res.data);
        }
        resolve(res.data)
      }).catch(e => {
  			reject(e)
  		})

  	})
  },

}



const mutations = {
	[CONFIG](state, data) {
		state.config = data
    sessionStorage.setItem("config",JSON.stringify(data));
	},

  [ARTICLE](state, data) {
  	state.article = data
  },
	addGoods(state,data){
		if(state.shareInfo.goodsList.length == 0){
			Array.push(state.shareInfo.goodsList, data)
		}else{
			let contain = false;
			state.shareInfo.goodsList.forEach(element => {
				if (element.good_id == data.good_id && element.sku_price_id == data.sku_price_id){
					contain = true;
					element.goods_num += data.goods_num
				}
			});
			if (!contain){
				Array.push(state.shareInfo.goodsList, data)
			}
		}
	},
	setPerGoods(state,data){
		state.shareInfo.perGoodsList = data;
	},
	setDirectOrderInfo(state,data){
		state.shareInfo.directOrderInfo = data
		state.shareInfo.isDirect = true
	}
}

const getters = {
	getDirectOrderInfo(){
		return state.shareInfo.directOrderInfo;
	}
}

export default {
	state,
	mutations,
	actions,
	getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/shopro.js